import { render, staticRenderFns } from "./exerciseselector.vue?vue&type=template&id=662a0418"
import script from "./exerciseselector.vue?vue&type=script&lang=js"
export * from "./exerciseselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports